import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=6c66e6f9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ros-kepler-tecowebsite(r项目开发者平台)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c66e6f9"]])

export default __exports__